import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-master',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './master.component.html',
})
export class MasterComponent {}
